import { openBlock as e, createElementBlock as o, createElementVNode as t } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ t("path", {
  fill: "#FFDA44",
  d: "m10.841 37.785 14.693-12.25 12.25-14.694a20.089 20.089 0 0 0-8.614-8.62L14.465 14.466 2.221 29.17a20.087 20.087 0 0 0 8.62 8.615Z"
}, null, -1), c = /* @__PURE__ */ t("path", {
  fill: "#D80027",
  d: "M34.142 34.143c6.31-6.31 7.521-15.787 3.637-23.314l-26.95 26.95c7.527 3.885 17.003 2.673 23.313-3.636Z"
}, null, -1), s = /* @__PURE__ */ t("path", {
  fill: "#6DA544",
  d: "M5.857 5.857c-6.31 6.31-7.52 15.786-3.636 23.313L29.17 2.221C21.643-1.663 12.167-.452 5.857 5.857Z"
}, null, -1), d = [
  n,
  c,
  s
];
function i(r, _) {
  return e(), o("svg", l, [...d]);
}
const h = { render: i };
export {
  h as default,
  i as render
};
